var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asignacionNoSeriado" },
    [
      _c(
        "div",
        {
          staticClass: "layout row wrap",
          staticStyle: {
            "padding-right": "0px",
            "padding-left": "10px",
            "padding-top": "15px"
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-autocomplete", {
                attrs: {
                  "item-text": "tipofecha_nombre",
                  items: _vm.filtro_tipo_fecha,
                  "item-value": "tipofecha_id",
                  label: "Tipo Fecha",
                  "prepend-icon": "supervisor_account",
                  required: ""
                },
                on: {
                  change: function($event) {
                    return _vm.updateDateTypeFilter()
                  }
                },
                model: {
                  value: _vm.model_tipo_fecha,
                  callback: function($$v) {
                    _vm.model_tipo_fecha = $$v
                  },
                  expression: "model_tipo_fecha"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("DatePicker", {
                attrs: {
                  locale: "es-cl",
                  color: "primary",
                  label: _vm.titleStartDate
                },
                model: {
                  value: _vm.model_filtro_inicio,
                  callback: function($$v) {
                    _vm.model_filtro_inicio = $$v
                  },
                  expression: "model_filtro_inicio"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("DatePicker", {
                attrs: {
                  locale: "es-cl",
                  color: "primary",
                  label: _vm.titleEndDate
                },
                model: {
                  value: _vm.model_filtro_fin,
                  callback: function($$v) {
                    _vm.model_filtro_fin = $$v
                  },
                  expression: "model_filtro_fin"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Coordinador",
                  "item-text": "coorname",
                  "item-value": "coorid",
                  items: _vm.filtro_coordinador,
                  clearable: "",
                  "prepend-icon": "speed"
                },
                model: {
                  value: _vm.model_filtro_coordinador,
                  callback: function($$v) {
                    _vm.model_filtro_coordinador = $$v
                  },
                  expression: "model_filtro_coordinador"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "flex xs6 sm3 md1" }, [
            _c(
              "div",
              { staticClass: "text-sm-center botones-filtros" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.applyfilters } },
                  [
                    _c("v-icon", { attrs: { color: "#27488e" } }, [
                      _vm._v("search")
                    ]),
                    _vm._v("Filtrar")
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "layout row wrap",
          staticStyle: { "padding-right": "0px", "padding-left": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Técnico",
                  "item-text": "tecniconame",
                  "item-value": "tecnicoid",
                  items: _vm.filtro_tecnico,
                  clearable: "",
                  "prepend-icon": "speed"
                },
                model: {
                  value: _vm.model_filtro_tecnico,
                  callback: function($$v) {
                    _vm.model_filtro_tecnico = $$v
                  },
                  expression: "model_filtro_tecnico"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Cliente",
                  "item-text": "nombre",
                  "item-value": "rut",
                  items: _vm.filtro_cliente,
                  clearable: "",
                  "prepend-icon": "account_circle"
                },
                on: { change: _vm.handleFLotasFilter },
                model: {
                  value: _vm.model_filtro_cliente,
                  callback: function($$v) {
                    _vm.model_filtro_cliente = $$v
                  },
                  expression: "model_filtro_cliente"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: _vm.flotaName,
                  "item-text": "__nom_flota",
                  "item-value": "cod_flota",
                  items: _vm.filtro_flota,
                  clearable: "",
                  "prepend-icon": "local_shipping"
                },
                model: {
                  value: _vm.model_filtro_flota,
                  callback: function($$v) {
                    _vm.model_filtro_flota = $$v
                  },
                  expression: "model_filtro_flota"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              {
                                attrs: {
                                  label: "Buscar Patente...",
                                  clearable: "",
                                  "prepend-icon": "directions_car",
                                  "append-icon": "search"
                                },
                                model: {
                                  value: _vm.model_filtro_patente,
                                  callback: function($$v) {
                                    _vm.model_filtro_patente = $$v
                                  },
                                  expression: "model_filtro_patente"
                                }
                              },
                              on
                            )
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n          Puedes realizar la búsqueda de la patente con el signo menos\n          (PPPP-22) o sin el (PPPP22)\n        "
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _c("div", { staticClass: "flex xs6 sm3 md1" }, [
            _c(
              "div",
              { staticClass: "text-sm-center botones-filtros" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.cleanfilters } },
                  [
                    _c("v-icon", { attrs: { color: "#27488e" } }, [
                      _vm._v("clear")
                    ]),
                    _vm._v("Limpiar")
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "layout row wrap",
          staticStyle: { "padding-right": "0px", "padding-left": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Buscar Alta...",
                  clearable: "",
                  "prepend-icon": "description",
                  "append-icon": "search"
                },
                model: {
                  value: _vm.model_filtro_alta,
                  callback: function($$v) {
                    _vm.model_filtro_alta = $$v
                  },
                  expression: "model_filtro_alta"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Equipo",
                  "item-text": "tipoeqname",
                  "item-value": "tipoeqid",
                  items: _vm.filtro_equipo,
                  clearable: "",
                  "prepend-icon": "home_repair_service"
                },
                model: {
                  value: _vm.model_filtro_equipo,
                  callback: function($$v) {
                    _vm.model_filtro_equipo = $$v
                  },
                  expression: "model_filtro_equipo"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Tipo de Alta",
                  "item-text": "tipoAlta",
                  "item-value": "tipoAltaId",
                  items: _vm.filtro_tipo_alta,
                  clearable: "",
                  "prepend-icon": "install_desktop"
                },
                model: {
                  value: _vm.model_filtro_tipo_alta,
                  callback: function($$v) {
                    _vm.model_filtro_tipo_alta = $$v
                  },
                  expression: "model_filtro_tipo_alta"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm2 md2" },
            [
              _c("v-select", {
                staticStyle: { "justify-content": "center" },
                attrs: {
                  label: "Anulado",
                  "item-text": "anulado",
                  "item-value": "anuladoId",
                  items: _vm.filtroAnulado,
                  clearable: "",
                  "prepend-icon": "clear"
                },
                model: {
                  value: _vm.model_filtro_anulado,
                  callback: function($$v) {
                    _vm.model_filtro_anulado = $$v
                  },
                  expression: "model_filtro_anulado"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "layout row wrap",
          staticStyle: { "padding-right": "0px", "padding-left": "10px" }
        },
        [
          _c("div", {
            staticClass: "flex xs12 sm6 md6",
            attrs: { align: "lef" }
          }),
          _c(
            "div",
            {
              staticClass: "flex xs12 sm6 md6 layout row wrap",
              attrs: { align: "right" }
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    sm9: "",
                    md9: "",
                    layout: "",
                    "justify-end": "",
                    "align-center": "",
                    "mt-3": "",
                    "mb-4": ""
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.btn_exportar("informes")
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("cloud_download")
                      ]),
                      _vm._v("\n            \n          "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Exportar"),
                        _c("br"),
                        _vm._v("Informes")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  attrs: {
                    sm3: "",
                    md3: "",
                    layout: "",
                    "justify-end": "",
                    "align-center": "",
                    "mt-3": "",
                    "mb-4": ""
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.btn_exportar("csv")
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("cloud_download")
                      ]),
                      _vm._v("\n            \n          "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Exportar"),
                        _c("br"),
                        _vm._v("CSV")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "btn-crear v-btn theme--light",
                  on: { click: _vm.handlerbuttonmodal }
                },
                [
                  _c(
                    "i",
                    {
                      staticClass:
                        "v-icon v-icon--left material-icons theme--dark",
                      staticStyle: { color: "black" },
                      attrs: { "aria-hidden": "true" }
                    },
                    [_vm._v("add_circle_outline")]
                  ),
                  _c("span", [_vm._v("Crear")])
                ]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "v-card",
        [
          _c(
            "div",
            { staticClass: "gridcard rounded-card grilla_altas_serivcio" },
            [
              _c("MantenedorGridSinCodigo", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "funcionalidad-id": _vm.funcionalidad
                }
              })
            ],
            1
          ),
          _vm.AltaServicioModalState
            ? _c("modalVerDetalleAltaServicio", {
                attrs: {
                  show: _vm.AltaServicioModalState,
                  id_alta_serv: _vm.AltaServicio_Seleccionada,
                  numero_orden: _vm.numero_orden_Seleccionada,
                  accion_modal: _vm.accion_modal,
                  data: _vm.data,
                  esEdicion: _vm.esEdicion
                },
                on: {
                  modalverDetalleEmit: function($event) {
                    return _vm.modalverDetalleCallback($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm.dialogModalEditar
        ? _c("ModalEditarAlta", {
            attrs: {
              data: _vm.data,
              filtroCoordinador: _vm.filtro_coordinador,
              filtroFlota: _vm.filtro_flota,
              esEdicion: _vm.esEdicion
            },
            on: { closeModal: _vm.handleCloseModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }